module.exports = __webpack_public_path__ + "static/img/index_newsideNav_code3.5849324.a375697.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index_newsideNav_code3.5849324.png
// module id = xpak
// module chunks = 1